import {
  buildProjectedIncrementalSalesChartProps,
  buildTotalProjectedSalesChartProps,
} from '@features/campaigns/subdomains/cpg';
import { CpgRetailer } from '@features/campaigns/subdomains/cpg';
import { donutChartOptions } from '@features/campaigns/subdomains/cpg/configuration/donut-chart-options';
import { getSummaryRetailers } from '@features/campaigns/subdomains/cpg/domain/summary-retailers';
import { annotationsTextContent } from '@features/lci-report/slides/shared/annotations-text';
import { contentSlideHeader } from '@features/lci-report/utils';
import {
  chartOptionsToBase64Svg,
  ImageProps,
  Slide,
} from '@features/powerpoint';
import { ValueInput } from '@utils/formattersV2';

const CHART_WIDTH = 600;
const CHART_HEIGHT = 600;

const DEFAULT_IMAGE_OPTIONS: ImageProps = {
  h: 2.6,
  w: 4.25,
  y: 2.45,
};

type RetailersSummarySlideProps = {
  retailers: Pick<
    CpgRetailer,
    | 'name'
    | 'projectedIncrementalSales'
    | 'totalProjectedSales'
    | 'statisticallySignificant'
  >[];
  projectedIncrementalSales: ValueInput;
  totalProjectedSales: ValueInput;
  slideMaster: string;
  keyTakeaways: string[];
  recommendation: string;
};

export const retailersSummarySlide = (
  props: RetailersSummarySlideProps
): Slide => {
  const filteredRetailers = getSummaryRetailers(props.retailers);

  return {
    slideMaster: props.slideMaster,
    texts: [
      contentSlideHeader('Retailer Summary'),
      ...annotationsTextContent(
        props.keyTakeaways,
        props.recommendation.length > 0 ? [props.recommendation] : []
      ),
      {
        text: 'Projected Incremental Sales',
        options: {
          x: 2.91,
          y: 1.99,
          h: 0.47,
          w: 3.26,
          fontSize: 10,
          align: 'center',
          bold: true,
          valign: 'middle',
        },
      },
      {
        text: 'Total Projected Sales',
        options: {
          x: 7.62,
          y: 1.96,
          h: 0.47,
          w: 3.26,
          fontSize: 10,
          align: 'center',
          bold: true,
          valign: 'middle',
        },
      },
    ],
    images: [
      {
        ...DEFAULT_IMAGE_OPTIONS,
        data: chartOptionsToBase64Svg({
          chartOptions: donutChartOptions(
            buildProjectedIncrementalSalesChartProps(
              filteredRetailers,
              props.projectedIncrementalSales
            )
          ),
          width: CHART_WIDTH,
          height: CHART_HEIGHT,
        }),
        x: 2.41,
      },
      {
        ...DEFAULT_IMAGE_OPTIONS,
        data: chartOptionsToBase64Svg({
          chartOptions: donutChartOptions(
            buildTotalProjectedSalesChartProps(
              filteredRetailers,
              props.totalProjectedSales
            )
          ),
          width: CHART_WIDTH,
          height: CHART_HEIGHT,
        }),
        x: 7.12,
      },
    ],
  };
};
